"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncSchema = exports.SyncProgressSchema = exports.SyncPayloadSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.SyncPayloadSchema = __1.BaseSchema.extend({
    channelPayloadId: __1.ShortStringSchema.uuid(),
    status: zod_1.z.nativeEnum(__1.PayloadStatus),
    syncedPayload: __1.ItemSchema.or(__1.OrderSchema),
    existentPayload: __1.ItemSchema.or(__1.OrderSchema).optional(),
    importAction: zod_1.z.nativeEnum(__1.ImportAction).optional(),
});
exports.SyncProgressSchema = zod_1.z.object({
    progressPercentage: zod_1.z.number(),
    /**
     * How many payloads are available on a given channel to be exported.
     *
     * The value might change during the sync data export process.
     */
    availableToExport: zod_1.z.number(),
    /**
     * How many payloads were exported from a given channel.
     *
     * The value might change during the sync data export process.
     */
    exported: zod_1.z.number(),
    /**
     * How many payloads weren't exported from a given channel due to errors.
     *
     * Reach out to our support team if you need help to understand or fix these errors.
     */
    failedToExport: zod_1.z.number(),
    /**
     * How many payloads were skipped on export from a given channel.
     *
     * Some RediRedi limitations or business rules might prevent some payloads from being exported.
     * For instance, an item payload might be skipped if it contains variants.
     */
    skippedOnExport: zod_1.z.number(),
    /**
     * Once the sync data export process is finished, this property will indicate how many exported payloads has a conflict with existent RediRedi data.
     */
    conflict: zod_1.z.number(),
    /**
     * Payloads previously succesfully synced aren't synced again, this property will indicate how many exported payloads are not present on the sync due to such restriction.
     */
    previouslySynced: zod_1.z.number(),
    /**
     * Payloads might be ignored, this property will indicate how many exported payloads are not present on the sync due to such restriction.
     */
    ignored: zod_1.z.number(),
    /**
     * How many payloads are available and ready to be saved on RediRedi.
     */
    readyToSave: zod_1.z.number(),
    /**
     * How many payloads were not saved on RediRedi due to any failure.
     *
     * Reach out to our support team if you need help to understand or fix these errors.
     */
    failedToSave: zod_1.z.number(),
    /**
     * How many payloads were saved on RediRedi successfully.
     */
    saved: zod_1.z.number(),
});
exports.SyncSchema = __1.BaseSchema.extend({
    channel: __1.ChannelSchema.partial().required({ id: true }),
    status: zod_1.z.nativeEnum(__1.SyncStatus),
    store: __1.StoreSchema.partial().required({ id: true }),
    type: zod_1.z.nativeEnum(__1.SyncType),
    payloads: zod_1.z.array(exports.SyncPayloadSchema).optional(),
    /**
     * A sync might have a big amount of payloads, this property is used to indicate the relative path of the file that contains the payloads to be downloaded.
     */
    payloadsFilePath: __1.ShortStringSchema.optional(),
    progress: exports.SyncProgressSchema.optional(),
    statusReason: __1.MediumStringSchema.optional(),
});
//# sourceMappingURL=sync.js.map